import React from "react";
import "./Pagination.scss";
import { Button, Icon } from "@design-system/index";
import { ArrowLeft, ArrowRight } from '@icons';
export type PaginationProps = {
  totalPages: number;
  currentPage: number;
  onPageChange: (page: number) => void;
};

export const Pagination: React.FC<PaginationProps> = ({ totalPages, currentPage, onPageChange }) => {
  const generatePages = () => {
    let pages: (number | string)[] = [];
    if (totalPages <= 5) {
      // Show all pages if <= 5
      pages = Array.from({ length: totalPages }, (_, i) => i + 1);
    } else {
      // Always show first page
      pages.push(1);

      if (currentPage > 3) {
        pages.push("...");
      }

      const start = Math.max(2, currentPage - 1);
      const end = Math.min(totalPages - 1, currentPage + 1);

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (currentPage < totalPages - 2) {
        pages.push("...");
      }

      // Always show last page
      pages.push(totalPages);
    }
    return pages;
  };

  return (
    <div className="pagination-wrapper">
      {/* Previous Button */}
      <Button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        icon={<Icon icon={<ArrowLeft />} size={12} color="grey1" />}
        hoverIcon={<Icon icon={<ArrowLeft />} size={12} color="primary" />}
        size="small"
        variant="tertiary"
      />

      {/* Page Numbers */}
      {generatePages().map((page, index) =>
        typeof page === "number" ? (
          <button
            key={index}
            className={`pagination-number ${currentPage === page ? "active" : ""}`}
            onClick={() => onPageChange(page)}
          >
            {page}
          </button>
        ) : (
          <span key={index} className="pagination-ellipsis">
            {page}
          </span>
        )
      )}

      {/* Next Button */}
      <Button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        icon={<Icon icon={<ArrowRight />} size={12} color="grey1" />}
        hoverIcon={<Icon icon={<ArrowRight />} size={12} color="primary" />}
        size="small"
        variant="tertiary"
      />
    </div>
  );
};